export const FETCH_SERVICE_PORT_CONTACTS = 'fetch service port contacts';
export const FETCH_SERVICE_PORT_CONTACTS_SUCCESS = 'fetch service port contacts success';
export const FETCH_SERVICE_PORT_CONTACTS_FAILURE = 'fetch service port contacts failure';

export const FETCH_PORT_SERVICES_BY_COMPANY_ID = 'fetch port service by companyId';
export const FETCH_PORT_SERVICES_BY_COMPANY_ID_SUCCESS = 'fetch port service by companyId success';
export const FETCH_PORT_SERVICES_BY_COMPANY_ID_FAILURE = 'fetch port service by companyId failure';

export const RESET_PORT_SERVICES = 'reset service port';


export const fetchServicePortContacts = (data) => ({
  type: FETCH_SERVICE_PORT_CONTACTS,
  payload: data
});

export const fetchPortServicesByCompanyId = (data) => ({
  type: FETCH_PORT_SERVICES_BY_COMPANY_ID,
  payload: data
});

export const resetPortServices = () =>({
  type: RESET_PORT_SERVICES,
})


